
const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
const API_BASE_URL = 'https://api.giphy.com/v1/gifs';

export type GiphyImage = {
    id: string;
    url: string;
    alt: string;
    category?: 'trending' | 'reactions' | 'memes' | 'search';
};

export const giphyService = {
    async getTrending(limit = 20): Promise<GiphyImage[]> {
        if (!GIPHY_API_KEY) return [];

        try {
            const response = await fetch(`${API_BASE_URL}/trending?api_key=${GIPHY_API_KEY}&limit=${limit}&rating=g`);
            const data = await response.json();
            return data.data.map((gif: any) => ({
                id: gif.id,
                url: gif.images.downsized_medium.url,
                alt: gif.title,
                category: 'trending'
            }));
        } catch (error) {
            console.error('Error fetching trending GIFs:', error);
            return [];
        }
    },

    async search(term: string, limit = 20): Promise<GiphyImage[]> {
        if (!GIPHY_API_KEY) return [];

        try {
            const response = await fetch(`${API_BASE_URL}/search?api_key=${GIPHY_API_KEY}&q=${encodeURIComponent(term)}&limit=${limit}&rating=g`);
            const data = await response.json();
            return data.data.map((gif: any) => ({
                id: gif.id,
                url: gif.images.downsized_medium.url,
                alt: gif.title,
                category: 'search' // Dynamic category
            }));
        } catch (error) {
            console.error('Error searching GIFs:', error);
            return [];
        }
    }
};
